module.exports = __webpack_public_path__ + "img/ios1.67b70ee3.png";